import {
  FileText, Cpu, Layers, AlertTriangle, CheckCircle2, ArrowUpRight
} from 'lucide-react';

const pipelineSteps = [
  { key: 'upload', label: 'Upload', icon: FileText },
  { key: 'processing', label: 'Processing', icon: Cpu },
  { key: 'extraction_complete', label: 'Extracted', icon: Layers },
  { key: 'review', label: 'Review', icon: AlertTriangle },
  { key: 'sync_ready', label: 'Sync Ready', icon: CheckCircle2 },
  { key: 'sync_complete', label: 'Synced', icon: ArrowUpRight },
];

export function PipelineProgressBar({ pipelineStage }) {
  const currentStageIndex = pipelineSteps.findIndex((s) => s.key === pipelineStage);

  return (
    <div className="bg-card border border-border rounded-sm p-5 mb-6" data-testid="pipeline-progress">
      <div className="flex items-center gap-2 mb-3">
        <Cpu className="w-4 h-4 text-muted-foreground" />
        <span className="font-heading font-bold text-xs uppercase tracking-wider text-muted-foreground">Pipeline Progress</span>
      </div>
      <div className="flex items-center">
        {pipelineSteps.map((step, i) => {
          const isComplete = i <= currentStageIndex;
          const isCurrent = i === currentStageIndex;
          return (
            <div key={step.key} className="flex items-center flex-1">
              <div className={`flex items-center gap-2 px-3 py-1.5 rounded-sm text-[10px] font-heading uppercase tracking-wider ${
                isCurrent
                  ? 'bg-orange-600/10 text-primary border border-primary/30'
                  : isComplete
                  ? 'text-emerald-400'
                  : 'text-muted-foreground'
              }`}>
                <step.icon className="w-3.5 h-3.5" />
                <span>{step.label}</span>
              </div>
              {i < pipelineSteps.length - 1 && (
                <div className={`flex-1 h-px mx-2 ${isComplete ? 'bg-emerald-800' : 'bg-secondary'}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
